import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import DocumentUpload from './pages/DocumentUpload';
import Collections from './pages/Collections';
import Chat from './pages/Chat';
import RegulatorySearch from './pages/RegulatorySearch';
import Integrations from './pages/Integrations';
import Usage from './pages/Usage';
import Groups from './pages/Groups';
import Automations from './pages/Automations';
import Operator from './pages/Operator';
import Subscription from './pages/Subscription';
import Home from './pages/Home';
import Register from './pages/Register';
import Admin from './pages/Admin';
import Landing from './pages/Landing';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import Unsubscribe from './pages/Unsubscribe';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Rotas públicas (landing/marketing) — sem autenticação */}
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/descadastrar" element={<Unsubscribe />} />
        <Route path="/privacidade" element={<Privacy />} />
        <Route path="/termos" element={<Terms />} />

        {/* Todas as demais rotas exigem autenticação */}
        <Route path="/*" element={
          <ProtectedRoute>
            <Box minH="100vh" bg="gray.50">
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/inicio" element={<Home />} />
                  <Route path="/upload" element={<DocumentUpload />} />
                  <Route path="/collections" element={<Collections />} />
                  <Route path="/chat" element={<Chat />} />
                  <Route path="/regulatory" element={<RegulatorySearch />} />
                  <Route path="/integrations" element={<Integrations />} />
                  <Route path="/usage" element={<Usage />} />
                  <Route path="/groups" element={<Groups />} />
                  <Route path="/automations" element={<Automations />} />
                  <Route path="/operator" element={<Operator />} />
                  <Route path="/subscription" element={<Subscription />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Layout>
            </Box>
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
}

export default App;
